export enum TabType {
  STDOUT = 'stdout',
  STDERR = 'stderr',
}

export interface CodeBlock {
  language: string;
  code: string;
}
